import {
  Plane,
  BedDouble,
  UtensilsCrossed,
  Landmark,
  Umbrella,
  MapPin,
  Fuel,
  Mountain,
  Sparkles,
  TrainFront,
  Ship,
  ShoppingBag,
  Ticket,
  type LucideIcon,
} from 'lucide-react'
import type { PointStatus, PointType } from '../api/types'

export const POINT_TYPE_META: Record<PointType, { label: string; Icon: LucideIcon }> = {
  airport: { label: 'Airport', Icon: Plane },
  hotel: { label: 'Hotel', Icon: BedDouble },
  restaurant: { label: 'Restaurant', Icon: UtensilsCrossed },
  museum: { label: 'Museum', Icon: Landmark },
  beach: { label: 'Beach', Icon: Umbrella },
  stop: { label: 'Stop', Icon: MapPin },
  gas: { label: 'Gas station', Icon: Fuel },
  viewpoint: { label: 'Viewpoint', Icon: Mountain },
  station: { label: 'Station', Icon: TrainFront },
  port: { label: 'Port', Icon: Ship },
  shop: { label: 'Shop', Icon: ShoppingBag },
  event: { label: 'Event', Icon: Ticket },
  free: { label: 'Place', Icon: Sparkles },
}

export const POINT_STATUS_META: Record<PointStatus, { label: string; symbol: string; color: string }> = {
  planned: { label: 'Planned', symbol: '○', color: 'var(--color-st-muted)' },
  visited: { label: 'Visited', symbol: '●', color: 'var(--color-st-success)' },
  skipped: { label: 'Skipped', symbol: '⊘', color: 'var(--color-st-muted)' },
  changed: { label: 'Changed', symbol: '✎', color: 'var(--color-st-warning)' },
}

export const POINT_TYPE_OPTIONS = (Object.keys(POINT_TYPE_META) as PointType[]).map((value) => ({
  value,
  label: POINT_TYPE_META[value].label,
}))
